export const celebrationWords = "for any of your child's life celebrations.";
export const placesWords = "scenes from some of my favorite locations.";
export const familyWords = "time well spent with you and your loved ones.";
export const contactWords = "contact";
export const contactCopy = "My name is Lisa and I love taking photos. Some of my favorite things are tiny details, natural smiles and sweet moments. Any occasion is a special occasion, perfect for collecting memories to treasure for years."
